import { render, staticRenderFns } from "./Uwdrcr.vue?vue&type=template&id=7494d8b5&"
import script from "./Uwdrcr.vue?vue&type=script&lang=js&"
export * from "./Uwdrcr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports